import { useState } from 'react';
import { login } from '../api';

export default function Login({ onLogin }: { onLogin: () => void }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr(null);
    setLoading(true);
    try {
      await login(email, password);
      onLogin();
    } catch (e: any) {
      if (e.message === 'invalid_credentials') {
        setErr('E-Mail oder Passwort falsch.');
      } else if (e.message === 'TypeError: Failed to fetch' || e.message.includes('fetch')) {
        setErr('Backend nicht erreichbar. Läuft der Server?');
      } else {
        setErr(e.message ?? 'Unbekannter Fehler');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-overlay">
      <form className="login-box" onSubmit={onSubmit}>
        <div className="login-logo">B</div>
        <h1>Bertsy Admin</h1>
        <p>Bitte melde dich mit deinem Bertsy-Admin-Konto an.</p>

        <div className="field">
          <label htmlFor="email">E-Mail</label>
          <input
            id="email"
            type="email"
            autoFocus
            autoComplete="username"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setErr(null);
            }}
            placeholder="admin@bertsy.de"
            required
          />
        </div>

        <div className="field">
          <label htmlFor="pwd">Passwort</label>
          <input
            id="pwd"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setErr(null);
            }}
            placeholder="••••••••"
            required
          />
          {err && <div className="error">{err}</div>}
        </div>

        <button
          className="btn btn-primary"
          style={{ width: '100%' }}
          type="submit"
          disabled={loading || !email || !password}
        >
          {loading ? 'Anmelden…' : 'Anmelden'}
        </button>
      </form>
    </div>
  );
}
